import { firestore } from "../Firebase/config";
import {
  addDoc,
  collection,
} from "firebase/firestore";

export const setWorkoutData = async (userId) => {
  try {
    const docRef = await addDoc(collection(firestore, "workout"), {
      userId: userId,
      workoutPlane: {},
    });
    const id = docRef.id;
    return id;
  } catch (error) {
    // console.log(error);
  }
};

export const setDietData = async (userId) => {
    try {

        const docRef = await addDoc(collection(firestore, "diet"),
        {
            userId : userId,
            dietList : []
        });

        const id = docRef.id;
        return id;

    }catch(error) {
        // console.log(error)
    }
}
